/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function testimonialsSlider() {
  var slider = document.querySelector('.testimonials__slider  ');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'right',
    contain: true,
    wrapAround: true,
    prevNextButtons: true,
    autoPlay: 5000,
    pauseAutoPlayOnHover: false,
    on: {
      ready: function() {
        setTimeout(() => {
          flkty.resize()
        }, 500);
      }
    }
    // adaptiveHeight: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.testimonials__slider  ');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}
